import { observable, action, runInAction, makeObservable } from 'mobx';

export default class AppStore {
	rootStore;

	@observable initialized = false;

	constructor(rootStore) {
        makeObservable(this);
        this.rootStore = rootStore;
    }

	@action setInitialized(initialized) {
		const self = this;
		runInAction(() => (self.initialized = initialized));
	}

	@action async initialize() {
		await this.rootStore.localizationStore.initialize();
		runInAction(() => (this.initialized = true));
	}
}



// WEBPACK FOOTER //
// ./src/common/stores/AppStore.js